module.exports = __webpack_public_path__ + "static/img/exhibitFormTips7.0aadeb4a.png";